// extracted by mini-css-extract-plugin
export default {"heading":"TA-z","corrected":"UA-z","redirectVerbiageContainer":"VA-z","redirectVerbiageText":"WA-z"};